import { render, staticRenderFns } from "./DistrictBasicDetails.vue?vue&type=template&id=8d4f4f3e"
import script from "./DistrictBasicDetails.vue?vue&type=script&lang=js"
export * from "./DistrictBasicDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports